var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 0.166656C2.78033 0.166656 0.166992 2.77999 0.166992 5.99999C0.166992 9.21999 2.78033 11.8333 6.00033 11.8333C9.22033 11.8333 11.8337 9.21999 11.8337 5.99999C11.8337 2.77999 9.22033 0.166656 6.00033 0.166656ZM1.33366 5.99999C1.33366 3.42166 3.42199 1.33332 6.00033 1.33332C7.07949 1.33332 8.07116 1.70082 8.85866 2.31916L2.31949 8.85832C1.70116 8.07082 1.33366 7.07916 1.33366 5.99999ZM6.00033 10.6667C4.92116 10.6667 3.92949 10.2992 3.14199 9.68082L9.68116 3.14166C10.2995 3.92916 10.667 4.92082 10.667 5.99999C10.667 8.57832 8.57866 10.6667 6.00033 10.6667Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c5038aacd9283159d8acc2cf284d6c32.svg";
export { ForwardRef as ReactComponent };